module.exports = __webpack_public_path__ + "img/pwrrail_w.10d5f9eb.svg";